import styled, {keyframes, css} from 'styled-components';

const expandWidth = width => keyframes`
  from {
    width: ${0}%;
  }
  to {
    width: ${parseInt(width)}%;
  }
`;

const rotate = width => keyframes`
  from {
    left: -2%;
  }
  to {
    left:${parseInt(width) - 2}%;
  }
`;

// const expandedAnimation = props =>
//   css`
//     ${expandWidth(props.width)} 3s ease-in-out;
//   `;

// const rotateAnimation = props => css`
//   ${rotate} 3s ease-in-out;
// `;

export const GoStreakBarOuterWrapper = styled.ul(
  props => `
  display: flex;
  align-items:center;
  ${
    props.isMyEarning
      ? `
    transform: rotate(90deg);
    position: absolute;
    
    height: 50px;
    width: 430px;
    left: -168px;
    top: 289px;
  
  
    > svg {
        transform: rotate(-90deg);
        position: absolute;
        right: -40px;
        width: 52px;
        height: 52px;
        background: #FFF9F7;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 3rem;
        height: 3rem;
        cursor: pointer;
    
    }
    .giftIconWrapper {
      transform: rotate(-90deg);
        position: absolute;
        right: -67px;
        width: 52px;
        height: 52px;
        background: #FFF9F7;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
       > svg {
        width: 2.8rem;
        height: 2.8rem;
        margin-right: 8px;
      }
    }
  
  @media (max-width: 768px) {
    left: -176px;
    top: 294px;
    }`
      : null
  }
  
      `,
);

export const GoStreakBarWrapper = styled.ul(
  props => `
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-gap: 0.2rem;
  margin: 0.8rem 0;
  list-style-type: none;  
  flex: 1;
  position: relative;
  
      `,
);

export const BlockBarWrapper = styled.div(
  props => `
    position: absolute;
    background: white;
    width: 2px;
    height: 10px;
    left: ${props.left};
    top: 0;
    z-index: 5;
      `,
);

export const BlockProgress = styled.div`
  background: linear-gradient(309.42deg, #ff6d38 30.92%, #ff3a5c 100%);
  width: ${props => parseInt(props.width)}%;
  height: 10px;
  position: absolute;
  border-radius: 0.8rem 0 0 0.8rem;
  z-index: 3;
  animation: ${props => expandWidth(props.width)} 3s ease-in-out;
  &.first {
    border-radius: 0.8rem 0 0 0.8rem;
  }

  &.last {
    border-radius: 0.8rem;
  }
`;

export const BlockIndicator = styled.div(
  props => `
  background: #FFD3D3;
    width: 100%;
    height: 10px;
    position: absolute;
    border-radius: 0.8rem;
      `,
);

export const GoStreakBarWrapperItem = styled.li(
  props => `
    background: ${
      props.isComplete ? 'linear-gradient(309.42deg, #FF6D38 30.92%, #FF3A5C 100%)' : '#FFD3D3'
    };
    height: 10px;
    position:relative;

  :first-of-type {
    border-radius: 0.8rem 0 0 0.8rem;
  }

  :last-of-type {
    border-radius: 0 0.8rem 0.8rem 0;
  }
      `,
);

export const GoStreakBarIconWrapper = styled.div`
  z-index: 8;
  width: 2rem;
  height: 2rem;
  background: #ffffff;
  border: 0.5px solid ${props => props.theme.colors.goBrandOrange.base};
  border-radius: 50%;
  position: absolute;
  top: -0.5rem;
  left:${props => parseInt(props.width) - 2}%;
  // left: ${props => (props.count === 1 ? '-0.5rem' : '-1rem')};
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${props => rotate(props.width)} 3s ease-in-out;
  ${props =>
    props.isMyEarning
      ? ` 
      svg {
    transform: rotate(-90deg);
  }`
      : null}
`;

export const BlockProgressLoading = styled.div(
  props => `
  width: 100%;
  height: 10px;
  position: absolute;
  border-radius: 0;
  z-index: 4;
  overflow: hidden;

  &.first {
    border-radius: 0.8rem 0 0 0.8rem;
  }

  &.last {
    border-radius: 0 0.8rem 0.8rem 0;
  }
      `,
);

export const LoadingLineOuterWrapper = styled.div(
  props => `
  mix-blend-mode: overlay;
  opacity: 0.2;
  background: white;

  width: ${props.width};
  left: ${props.stayCount * 20}%;
  height: 10px;
  position: absolute;
  border-radius: 0;
  z-index: 4;
  overflow: hidden;

  &.first {
    border-radius: 0.8rem 0 0 0.8rem;
  }

  &.last {
    border-radius: 0 0.8rem 0.8rem 0;
  }
      `,
);

export const LoadingLine = styled.div(
  props => `
    position: absolute;
    height: 20px;
    width: 2px;
    background: #4F4F4F;
    transform: matrix(0.59, -0.71, 0.96, 0.54, 0, 0) rotate(80deg);
    left: ${props.index * 6}px;
    top: -5px
      `,
);
